import React, { useEffect, useState } from "react";
import styles from "./CardDevice.module.css";
import useAuthToken from "../../../hooks/useAuthToken";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../../context/ToastContext";
import config from "../../../settings/config";
import { useLocation } from 'react-router-dom';

const CardDevice = () => {
    const navigate = useNavigate();
    const token = useAuthToken();
    const location = useLocation();
    const device = location.state?.device;
    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [status, setStatus] = useState("");
    const [type, setType] = useState("");
    const [topic, setTopic] = useState("");
    const [buttonSwitch, setButtonSwitch] = useState(false);
    const { setToast } = useToast();
    const showToast = (message, type, time) => {
        setToast({ message, type });
        setTimeout(() => setToast(null), time);
    };

    return (
        <div className={styles.container}>

        </div>
    )
}

export default CardDevice;